<template>
  <header
    class="ba-relative ba-z-10 ba-flex ba-items-center ba-justify-between ba-p-3 ba-rounded-md ba-bg-current"
    :class="colorBase"
  >
    <div class="ba-flex ba-items-center">
      <figure
        class="ba-flex ba-flex-shrink-0 ba-h-6 ba-w-6 ba-mr-2 ba-rounded-full ba-bg-current ba-cursor-pointer"
        :class="colorWeak"
        @mouseenter="showTooltip = true"
        @mouseleave="showTooltip = false"
      >
        <component :is="`vis-icon-${icon}`" class="ba-w-3 ba-h-4 ba-m-auto" :class="colorBase" />
      </figure>
      <h3 class="ba-text-sm ba-font-semibold ba-text-white">
        <span
          class="ba-mr-2 ba-tracking-wide ba-uppercase"
          :class="colorWeak"
        >
          {{ stage.stage }}
        </span>
        <span>{{ stage.title }}</span>
      </h3>
    </div>
    <visApprovalQueueStageEditControls v-if="stage.state === 'очередь не запущена'"/>
    <transition name="fade">
      <vis-approval-queue-tooltip
        v-show="showTooltip"
        :queueType="stage.queueType"
      />
    </transition>
  </header>
</template>

<script>
import visApprovalQueueStageEditControls from "./vis-approval-queue-stage-edit-controls";
import visApprovalQueueTooltip from "./vis-approval-queue-tooltip";

export default {
  name: "vis-approval-queue-stage-header",
  components: {
    visApprovalQueueStageEditControls,
    visApprovalQueueTooltip
  },
  props: {
    stage: {
      type: Object,
      default: () => ({})
    },
    colorBase: {
      type: String,
      default: null
    },
    colorWeak: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      showTooltip: false
    }
  }
}
</script>
